import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { textDecorationConverterMap } from './textDecorationPropsToCss'

/**
 * Enriches the converters registry with all TextDecoration style property converters.
 * TextDecoration converters handle CSS text-decoration properties including line, style, and color.
 */
export function enrichTextDecorationConverters(): void {
	// Register all text decoration converters
	Object.entries(textDecorationConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
